import React from "react";
import { Remarkable } from "remarkable";

const md = new Remarkable();

export const Markdown = ({ content }) => {
  return <div dangerouslySetInnerHTML={{ __html: md.render(content) }} />;
};
